module.exports = __webpack_public_path__ + "img/vehicleTypesIllustrations.bd0880ad.svg";